/**
 * Nota de ANOTAÇÕES de correção do PnL (28/09 — anotar o dado, nunca reescrever
 * o valor). Uma linha por linha do pnl_historico anotada DENTRO da janela da
 * série do card: causa + Δ corretos medidos (VF e VP) + o que não foi afetado.
 * O ponto no sparkline mantém o valor GRAVADO (guard B3) e ganha o marcador;
 * esta nota é onde o leitor do card vê o número certo. Gatilho = a API trouxe
 * a anotação (estado), nunca uma data no código.
 */
import { fmtBRLintSigned } from "../../utils/formatters";
import type { AnotacaoCorrecao } from "../../api/types";

const ROTULO: Record<string, string> = {
  diario: "Diário", semanal: "Semanal", mensal: "Mensal", anual: "Anual",
  diario_ipca: "Diário IPCA", semanal_ipca: "Semanal IPCA",
  mensal_ipca: "Mensal IPCA", anual_ipca: "Anual IPCA",
};
const ORDEM = ["diario", "semanal", "mensal", "diario_ipca", "semanal_ipca", "mensal_ipca"];

/** ISO "YYYY-MM-DD" → "DD/MM" (string pura — imune a timezone). */
function ddmm(iso: string): string {
  return `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
}

export function NotaAnotacoesCorrecao({ anotacoes }: { anotacoes: AnotacaoCorrecao[] }) {
  if (anotacoes.length === 0) return null;
  return (
    <div className="mt-2 space-y-1" data-testid="resultado-anotacoes">
      {anotacoes.map((a) => {
        const janelas = ORDEM.filter((j) => a.valores[j]);
        const naoAfet = a.nao_afetados.map((j) => ROTULO[j] ?? j).join(" e ");
        return (
          <div
            key={a.data_referencia}
            className="text-[11px] leading-snug text-amber-300/90"
            data-testid={`resultado-anotacao-${a.data_referencia}`}
          >
            {janelas.length === 0 ? (
              // 13/10: anotação sem par gravado×correto (ex.: troca de população
              // da ponta IPCA) — a causa completa é a explicação.
              <>⚠ {ddmm(a.data_referencia)} (fech. {ddmm(a.as_of)}): {a.causa} ({a.referencia}).</>
            ) : (
            <>
            ⚠ {ddmm(a.data_referencia)} (fech. {ddmm(a.as_of)}): Δ gravados com{" "}
            {a.causa_curta} ({a.referencia}). Corretos:{" "}
            {janelas.map((j, i) => {
              const v = a.valores[j];
              return (
                <span key={j} data-testid={`resultado-anotacao-${a.data_referencia}-${j}`}>
                  {i > 0 ? " · " : ""}
                  {ROTULO[j]} {fmtBRLintSigned(v.correto_vf)}
                  {v.correto_vp !== null ? ` (VP ${fmtBRLintSigned(v.correto_vp)})` : ""}
                </span>
              );
            })}
            .{naoAfet ? ` ${naoAfet} não afetado.` : ""} Valor gravado mantido.
            </>
            )}
          </div>
        );
      })}
    </div>
  );
}
